<template>
  <div class="e-topbar">
    <ul class="list-items">
      <li class="item mobile-menu-toggle">
        <button class="mobile-menu-button" type="button" @click="$emit('toggleMobileMenu')" :aria-expanded="mobileMenuOpen ? 'true' : 'false'" aria-label="Toggle menu">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </li>
      <li class="item go-back">
        <e-button type="link" @click="$router.back()">
          <img src="/static/icons/topbar-arrow-left.svg"/>
        </e-button>
      </li>
      <transition name="fade" mode="out-in">
      <li class="item page-title" v-if="pageTitle" >
          <a href="#" class="link">
            {{ pageTitle }}
          </a>
      </li>
      </transition>

    </ul>
    <ul class="list-items align-right">
      <!-- <li class="item">
        <e-button type="link">
          <img src="../../../assets/icons/activity.svg"/>
          <e-badge color="red">2</e-badge>
        </e-button>
      </li> -->
      <li class="item notifications-item" data-v-step="2">
        <b-dropdown
          :offset="calculatedOffset"
          right
          toggle-class="e-dropdown__toggle"
          menu-class="e-dropdown__menu e-dropdown__menu--center"
          @show="updateActivityList"
          class="e-dropdown notify-dropdown"
          :class="{'notify-dropdown-loading': loading}"
          ref="notifyDropdown">
          <template slot="button-content" class="link">
            <img src="../../../assets/icons/bell.svg"/>
            <e-badge color="red" v-if="user.notificationCount > 0">{{ user.notificationCount }}</e-badge>
          </template>
          <b-dropdown-item v-for="item in activity" class="e-dropdown__item notify-dropdown-item" :key="item.id" @click="goTo('activity')">
            <div class="activity-image">
              <img :src="item.image"/>
            </div>
            <div class="activity-content">
              <h3>{{ item.message }}</h3>
              <span>{{ formattedDate(item.date) }}</span>
            </div>
          </b-dropdown-item>
          <b-dropdown-item class="e-dropdown__item notify-dropdown-item notify-button" @click="goTo('activity')">
            <span>See all</span>
          </b-dropdown-item>
        </b-dropdown>
      </li>
      <li class="item balance-item" data-v-step="1">
        <a href="#" class="link">
          <div class="link-content">
            Balance: <span class="eh-text-blue-light font-weight-bold">{{ user.balance || 0 }} EMiX</span>
          </div>
        </a>
      </li>
      <li class="item user-item">
        <transition name="fade" mode="out-in">
          <b-dropdown key="user-data" :offset="-40" right toggle-class="e-dropdown__toggle e-topbar__dropdown-toggle" menu-class="e-dropdown__menu e-dropdown__menu--top e-topbar__dropdown-menu" class="e-dropdown e-topbar__dropdown">
            <template v-if="!$wait.is('auth.fetchUserData')" slot="button-content">
              <template v-if="isAuth">
                <div class="e-avatar">
                  <!-- <img :src="user.avatar"/> -->
                  <img :src="'https://randomuser.me/api/portraits/men/34.jpg'"/>
                </div>
                <div class="e-topbar__text">
                  <div class="e-topbar__username">{{ fullname }}</div>
                  <small class="eh-secondary-text">24 th</small>
                </div>
              </template>
              <template v-else>
                <e-button type="link">Login</e-button>
              </template>
            </template>
            <template v-else slot="button-content">
              <div class="e-avatar fake"></div>
              <div class="e-topbar__text">
                <div class="e-topbar__username e-mock e-mock__text"></div>
                <small class="eh-secondary-text e-mock e-mock__text e-mock--size--small"></small>
              </div>
            </template>
            <b-dropdown-item class="e-dropdown__item" @click="goTo('account')">Account</b-dropdown-item>
            <b-dropdown-item class="e-dropdown__item" @click="handleLogout">Logout</b-dropdown-item>
          </b-dropdown>
        </transition>
      </li>
    </ul>
  </div>

</template>

<script>
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
  import generateTemplateString from "@utils/templateString";
  import Services from "../../../services";

  import _ from 'lodash';
  import moment from 'moment';

	export default {
		name: "e-topbar",
    props: {
      mobileMenuOpen: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters('auth', [
        'fullname',
        'isAuth'
      ]),
      ...mapGetters('settings', ['pageTitle']),
      ...mapState('auth', {
        user: state => state.user,
      }),
      computedStyle() {
        return {
          paddingLeft: this.menuIsOpen ? '230px' : '110px',
        }
      }
    },
    methods: {
      ...mapActions('auth', [
        'updateUserData',
        'logout'
      ]),
      ...mapMutations('auth', {
        decrementNotificationCount: 'decrementNotificationCount',
      }),
      goTo(name) {
        this.$router.push({name})
      },
      handleLogout() {
        this.logout();
        // this.$router.push({name: 'signin'});
        window.location.href = process.env.NODE_ENV === 'production' ? 'https://economix.ai/login' : 'http://localhost:8082/login'
        return;
      },
      async updateActivityList() {
        this.loading = true;

        const {data} = await Services.Auth.getUserActivityList({limit: 5, sort: '-createdAt'});

        this.activity = data.items.map(item => {
          if(item.showed === false) {
            this.decrementNotificationCount();
          }

          const params = _.mapValues(item.message.params, (value, key) => {
            if(key === 'date' && typeof value === 'object') {
              return moment(value.date).format(value.format);
            }

            return value;
          });

          return {
            id: item._id,
            message: generateTemplateString(item.message.template)(params),
            image: item.message.image,
            showed: item.showed,
            date: item.createdAt,
          };
        });

        this.loading = false;

        this.$nextTick(() => {
          let dropdown = this.$refs.notifyDropdown.$el.childNodes[2];
          this.calculatedOffset = dropdown.clientWidth / 2 - 37;
        })
      },
      formattedDate(date) {
        return this.$moment(date).fromNow();
      },
    },
    data() {
		  return {
		    menuIsOpen: true,
        activity: [],
        loading: true,
        calculatedOffset: 0,
      }
    },
    created() {
      this.updateUserData();
    },
    beforeCreate() {
      this.$root.$on('ex::sidebar::toggleMenu', (o) => {
        this.menuIsOpen = o;
      });
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/topbar/topbar.vue